import * as Y from "yjs";

function isText(node: Node): boolean {
  return node.nodeType === Node.TEXT_NODE;
}

function traverse(node: Node, parentType: Y.XmlElement | Y.XmlFragment) {
  if (isText(node)) {
    const text = new Y.XmlText(node.textContent);
    parentType.insert(parentType.length, [text]);
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    // Set attributes
    if (parentType && parentType.setAttribute) {
      for (const attr of node.attributes) {
        parentType.setAttribute(attr.name, attr.value);
      }
    }

    if (node.nodeName == "textStyle") {
      console.log("element text", node.textContent);
      const text = new Y.XmlText(node.textContent);
      parentType.insert(parentType.length, [text]);
    } else if (node.nodeName == "bold") {
      console.log("YESSSS HIIII");
      // let element = new Y.XmlElement("text");
      // element.setAttribute("marks", "bold")
      // element.insert()
      const text = new Y.XmlText(node.textContent);
      // element.insert(0, [text]);
      parentType.insert(parentType.length, [text]);
    } else {
      let element = new Y.XmlElement(node.nodeName);
      parentType.insert(parentType.length, [element]);
      node.childNodes.forEach((childNode) => traverse(childNode, element));
    }
  }
}

export function convertXmlToYjs(xmlString: string): Y.XmlFragment {
  const doc = new Y.Doc();
  const xmlFragment = doc.getXmlFragment("xml");

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  traverse(xmlDoc.documentElement, xmlFragment);

  return xmlFragment;
}
